export default __webpack_public_path__ + "static/lgbtqia2splus-hero-c3fe52574ccdb8c77dbe1505e18fb2bd.webp";